import React from "react";

const eligibilityItems = [
  "Belong to a notified minority community.",
  "Meet the family income criteria prescribed by NMDFC.",
  "Be a member of a Self-Help Group, Joint Liability Group, or other eligible group, wherever applicable.",
  "Be willing to undertake or expand an income-generating activity.",
  "Comply with the eligibility conditions prescribed by the implementing agency.",
];

const documentItems = [
  "Loan application form",
  "Aadhaar Card",
  "Identity and address proof",
  "Income certificate",
  "Passport-size photographs",
  "SHG/JLG membership details (where applicable)",
  "Bank account details",
  "Activity proposal or business plan",
  "Any other documents required by the implementing agency",
];

const purposeItems = [
  "Starting new micro-enterprises",
  "Expanding existing small businesses",
  "Purchase of tools, equipment, machinery, or livestock",
  "Purchase of raw materials and inventory",
  "Meeting day-to-day working capital requirements",
  "Creating self-employment opportunities",
  "Improving household income and promoting sustainable livelihoods",
];

const VirasatSchemeContent = () => {
  return (
    <div className="space-y-7 text-[#333333]">
      <section className="space-y-3">
        <h2 className="text-lg font-bold text-[#183967]">Introduction</h2>
        <p className="text-justify text-[15px] leading-[1.75] text-[#111827]">
          The NMDFC Micro Finance Scheme is designed to provide small-value
          loans to economically weaker individuals belonging to notified
          minority communities for undertaking income-generating activities.
          Implemented primarily through Self-Help Groups (SHGs), Joint Liability
          Groups (JLGs), and partner organizations, the scheme promotes
          financial inclusion, women empowerment, and sustainable
          self-employment at the grassroots level.
        </p>
        <p className="text-justify text-[15px] leading-[1.75] text-[#111827]">
          The Virasat Scheme is a component of the NMDFC Term Loan Scheme and
          has been introduced to meet the credit requirements of artisans from
          notified minority communities. The scheme provides financial
          assistance for both working capital and fixed capital requirements,
          including the purchase of equipment, tools, and machinery.
        </p>
      </section>

      <section className="space-y-2">
        <h2 className="text-lg font-bold text-[#183967]">Eligibility</h2>
        <p className="text-[15px] leading-[1.7] text-[#111827]">
          Applicants must:
        </p>
        <ul className="ml-6 list-disc space-y-1.5 text-[15px] leading-[1.65] text-[#111827]">
          {eligibilityItems.map((item) => (
            <li key={item}>{item}</li>
          ))}
        </ul>
      </section>

      <section className="space-y-2">
        <h2 className="text-lg font-bold text-[#183967]">
          Documents Required
        </h2>
        <p className="text-[15px] leading-[1.7] text-[#111827]">
          Applicants are generally required to submit:
        </p>
        <ul className="ml-6 list-disc space-y-1.5 text-[15px] leading-[1.65] text-[#111827]">
          {documentItems.map((item) => (
            <li key={item}>{item}</li>
          ))}
        </ul>
      </section>

      <section className="space-y-2">
        <h2 className="text-lg font-bold text-[#183967]">Purpose of Loan</h2>
        <p className="text-[15px] leading-[1.7] text-[#111827]">
          The loan can be utilized for:
        </p>
        <ul className="ml-6 list-disc space-y-1.5 text-[15px] leading-[1.65] text-[#111827]">
          {purposeItems.map((item) => (
            <li key={item}>{item}</li>
          ))}
        </ul>
      </section>
    </div>
  );
};

export default VirasatSchemeContent;
